// extracted by mini-css-extract-plugin
export default {"choose_button":"Details_choose_button__cj1F8"};